const types = {
    SET_OTHER_PHYSIANS_CASE_COUNT_LOADING: 'SET_OTHER_PHYSIANS_CASE_COUNT_LOADING',
    SET_OTHER_PHYSICIANS_CASE_LIST_LOADING: 'SET_OTHER_PHYSICIANS_CASE_LIST_LOADING',
    SET_OTHER_PHYSICIANS_CASE_LIST: 'SET_OTHER_PHYSICIANS_CASE_LIST',
    SET_OTHER_PHYSICIANS_CASE_COUNT: 'SET_OTHER_PHYSICIANS_CASE_COUNT',
    REMOVE_CASE_FROM_OPC: 'REMOVE_CASE_FROM_OPC'
};

export default types;